import { GetServerSidePropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ParsedUrlQuery } from "querystring";
import getChannelConfigByPathName from "src/api/channel";
import RefundPolicy from "src/components/icth-product/refund-policy/RefundPolicy";
import { withLayout } from "src/components/Layout/withLayout";
import { LOGICAL_GROUP_CHANNEL_CODE } from "src/constants/logicalGroupChannelCode";

interface RefundPolicyPageParams extends ParsedUrlQuery {
  channelPath: string;
}

export async function getServerSideProps(
  context: GetServerSidePropsContext<RefundPolicyPageParams>
) {
  const channelPath = context.params?.channelPath;
  const locale = context.locale || "en";
  const channelConfig = await getChannelConfigByPathName(channelPath);

  if (
    !channelConfig ||
    channelConfig.logicalGroupChannelCode !== LOGICAL_GROUP_CHANNEL_CODE
  ) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      channelPath,
      channelConfig,
      isShowAnnouncement: false,
      title:
        locale === "th"
          ? "นโยบายการยกเลิกคำสั่งซื้อและการคืนเงิน"
          : "Purchase order canceling and refund policies",
      ...(await serverSideTranslations(locale, [
        "common",
        "cookie-consent",
        "layout",
        "refund-policy",
      ])),
    },
  };
}

export default withLayout(RefundPolicy);
